import MicOff from '@mui/icons-material/MicOff'
import Person from '@mui/icons-material/Person'
import SignalCellularAlt from '@mui/icons-material/SignalCellularAlt'
import { Box, Tooltip } from '@mui/material'
import React from 'react'

import { connectionMarker } from './utils'
import { SessionVideoTileAvatar } from './SessionVideoTileAvatar'

interface SessionVideoTileProps {
  quality: number | undefined
  muted: boolean | undefined
}

/**
 * Surfaces the quality of the connection to the user. The quality-to-colour mapping is shared with
 * the provider's own connection indicator via `connectionMarker`, so a tile and the indicator never
 * disagree about what a "poor" connection looks like.
 */
export const SessionVideoTile: React.FC<SessionVideoTileProps> = props => {
  const marker = connectionMarker(props.quality)
  return (
    <Box
      sx={theme => ({
        color: theme.palette.common.white,
        backgroundColor: theme.palette.grey[500],
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      })}
    >
      <Tooltip title={marker?.text ?? ''} placement="top">
        <Box
          sx={{
            position: 'absolute',
            bottom: '0.5em',
            right: '0.5em',
            zIndex: 100,
            display: 'flex',
          }}
        >
          {props.muted ? (
            <SessionVideoTileAvatar>
              <MicOff fontSize="small" />
            </SessionVideoTileAvatar>
          ) : null}
          {marker ? (
            <SessionVideoTileAvatar>
              <SignalCellularAlt fontSize="small" sx={{ color: marker.color }} />
            </SessionVideoTileAvatar>
          ) : null}
        </Box>
      </Tooltip>
      <Person color="inherit" />
    </Box>
  )
}
